import * as actionTypes from './actionTypes';

/*------------------------------------------------------------------------------------------------*/
/* Nav Actions                                                                                   */
/*------------------------------------------------------------------------------------------------*/
/**
 * Sends an event to close the navigation.
 */
export const closeNav = () => ({
  type: actionTypes.CLOSE_NAV,
});

export const openNav = (key: string) => ({
  type: actionTypes.OPEN_NAV,
  key,
});

export const toggleNav = (key: string) => ({ type: actionTypes.TOGGLE_NAV, key });
